import loadingGif from '../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { decodeToken, isExpired } from "react-jwt";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import "react-toastify/dist/ReactToastify.css";

function GridKarekod({ karekodFilterDTO, miktar }) {
    const [showBulk, setShowBulk] = useState(false);
    const handleCloseBulk = () => setShowBulk(false);
    const handleShowBulk = () => setShowBulk(true);

    const [showTek, setShowTek] = useState(false);
    const handleCloseTek = () => setShowTek(false);
    const handleShowTek = () => setShowTek(true);

    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(/*null*/ true);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [idData, setIdData] = useState(0);
    const [karekodGrubuIdData, setKarekodGrubuIdData] = useState(0);
    const [karekodData, setKarekodData] = useState("");
    const [sterilNoData, setSterilNoData] = useState("");
    const [miktarData, setMiktarData] = useState(0);
    const [veriData, setVeriData] = useState("");

    const [data, setData] = useState([]);

    const [pageNo, setPageNo] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    
    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            setShowBulk(false);
            setShowTek(false);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [pageNo, pageSize, karekodFilterDTO]);

    const handlePageSize = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
        await setPageSize(e);
    }

    const handlePageNo = async (e) => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(e);
    }

    const NavIlk = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(1);
    }

    const NavGeri = async () => {
        if ((pageNo - 1) >= 1) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(pageNo - 1);
        }
    }

    const NavIleri = async () => {
        if ((Number(pageNo) + 1) <= lastPage) {
            if (tokenYenile() === false) {
                return;
            }
            await setPageNo(Number(pageNo) + 1);
        }
    }

    const NavSon = async () => {
        if (tokenYenile() === false) {
            return;
        }
        await setPageNo(lastPage);
    }

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        //const apiurl = process.env.REACT_APP_API_URL;

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("Genel İşlemler - Karekod İşlemleri - Sil"));

            //await getData();
        }
    }

    const getData = async () => {
        const kriter = JSON.stringify({
            "karekodGrubuId": karekodFilterDTO.karekodGrubuId,
            "sort": "",
            "pageNo": pageNo,
            "pageSize": pageSize
        });

        try {
            setLoading(true);

            const res = await axios.post(settings.ApiUrl + 'Karekod/GetKarekodList', kriter, { headers: AuthService.getHeaders() });

            setRowCount(res.data.rowCount);
            setLastPage(Math.ceil(res.data.rowCount / pageSize));
            setData(res.data.value);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleExpandedKarekod = (indexKarekod, expanded) => {
        const tempData = [...data];

        tempData[indexKarekod].expanded = expanded;

        setData(tempData);
    };

    const Ekle = async () => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            setKarekodGrubuIdData(karekodFilterDTO.karekodGrubuId);
            setMiktarData(miktar);
            setVeriData("");

            handleShowBulk();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Karekod/GetKarekod/' + id, { headers: AuthService.getHeaders() });

            setIdData(res.data.value.id);
            setKarekodGrubuIdData(res.data.value.karekodGrubuId);
            setKarekodData(res.data.value.karekod);
            setSterilNoData(res.data.value.sterilNo);

            handleShowTek();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const KaydetBulk = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (veriData === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları giriniz", icon: "error" });
        //} else if (karekodData.length !== 46 && karekodData.length !== 47 && karekodData.length !== 48) {
            //Swal.fire({ title: "Hata", text: "Karekod 46, 47 veya 48 karakter olmalıdır", icon: "error" });
        } else {
            try {
                setLoading(true);

                const data = JSON.stringify({
                    "karekodGrubuId": karekodGrubuIdData,
                    "miktar": miktarData,
                    "veri": veriData
                });

                const result = await axios.post(settings.ApiUrl + 'Karekod/BulkInsertUpdateKarekod/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success === true) {
                        await getData();
                        toast.success("Kaydedildi");
                        document.getElementById("btnYenileKarekodGrubu" + karekodGrubuIdData).click();
                        handleCloseBulk();
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            } finally {
                setLoading(false);
            }
        }
    }

    const KaydetTek = async () => {
        if (tokenYenile() === false) {
            return;
        }

        if (karekodData === "" || sterilNoData === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları giriniz", icon: "error" });
        //} else if (karekodData.length !== 46 && karekodData.length !== 47 && karekodData.length !== 48) {
            //Swal.fire({ title: "Hata", text: "Karekod 46, 47 veya 48 karakter olmalıdır", icon: "error" });
        } else {
            try {
                setLoading(true);

                const data = JSON.stringify({
                    "id": idData,
                    "karekod": karekodData,
                    "sterilNo": sterilNoData,
                    "karekodUretilenList": []
                });

                const result = await axios.post(settings.ApiUrl + 'Karekod/UpdateKarekod/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success === true) {
                        await getData();
                        toast.success("Kaydedildi");
                        document.getElementById("btnYenileKarekodGrubu" + karekodGrubuIdData).click();
                        handleCloseTek();
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            } finally {
                setLoading(false);
            }
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    setLoading(true);

                    const resultGet = await axios.get(settings.ApiUrl + 'Karekod/GetKarekod/' + id, { headers: AuthService.getHeaders() });

                    if (resultGet && resultGet.data) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Karekod/DeleteKarekod/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                getData();
                                toast.success("Silindi");
                                document.getElementById("btnYenileKarekodGrubu" + resultGet.data.value.karekodGrubuId).click();
                            } else {
                                toast.error(resultDelete.data.message);        
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                } finally {
                    setLoading(false);
                }
            }
        });
    }

    return (
        <Fragment>
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <React.Fragment>
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                            <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div style={{ border: "0px solid silver" }}>
                                    <table className="table table-bordered table-hover table-sm mb-0">
                                        <thead>
                                            <tr key={"Karekod-1"}>
                                                <th style={{ textAlign: "center" }}></th>
                                                <th style={{ textAlign: "center" }}>Sıra No</th>
                                                <th style={{ textAlign: "center" }}>Okutulan Karekod</th>
                                                <th style={{ textAlign: "center" }}>Steril No</th>
                                                <th style={{ textAlign: "center" }}>
                                                    { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => Ekle()}><i className="bi bi-plus-circle"></i></button> : ''}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data && data.length > 0 ?
                                                    data.map((itemKarekod, indexKarekod) => {
                                                        return (
                                                            <React.Fragment>
                                                                <tr key={"Karekod" + indexKarekod}>
                                                                    <td align="center">
                                                                        <label htmlFor={"cbExpandedKarekod" + itemKarekod.id} style={{ cursor: "pointer" }}>
                                                                            <i className={itemKarekod.expanded === true ? "bi bi-chevron-down" : "bi bi-chevron-right"}></i>
                                                                        </label>
                                                                        <input id={"cbExpandedKarekod" + itemKarekod.id} type="checkbox" className="form-check-input" style={{ visibility: 'hidden' }} checked={itemKarekod.expanded} onChange={() => handleExpandedKarekod(indexKarekod, !itemKarekod.expanded)}></input>
                                                                    </td>
                                                                    <td align="center">{itemKarekod.sira}</td>
                                                                    <td align="center">{itemKarekod.karekod}</td>
                                                                    <td align="center">{itemKarekod.sterilNo}</td>
                                                                    <td align="center">
                                                                        <div className='btn-group'>
                                                                            {yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(itemKarekod.id)}><i className="bi bi-pencil"></i></button> : ''}
                                                                            {yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(itemKarekod.id)}><i className="bi bi-trash"></i></button> : ''}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                {
                                                                    itemKarekod.expanded === true ?
                                                                        <tr key={"KarekodExpand" + indexKarekod}>
                                                                            <td colSpan="5" style={{ padding: "1rem" }}>
                                                                                {
                                                                                    <div style={{ border: "0px solid silver", maxHeight:"280px", overflowY:"auto" }}>
                                                                                        <table className="table table-bordered table-hover table-sm mb-0">
                                                                                            <thead>
                                                                                                <tr>
                                                                                                    <th style={{ textAlign: "center" }}>Üretilen Karekod</th>
                                                                                                    <th style={{ textAlign: "center" }}>Ürün Ölçüleri</th>
                                                                                                    <th style={{ textAlign: "center" }}>Steril No</th>
                                                                                                    <th style={{ textAlign: "center" }}>Expire Date</th>
                                                                                                    <th style={{ textAlign: "center" }}>Seri No</th>
                                                                                                    <th style={{ textAlign: "center" }}>LOT</th>
                                                                                                    <th style={{ textAlign: "center" }}>Use By</th>
                                                                                                    <th style={{ textAlign: "center" }}>GTIN</th>
                                                                                                    <th style={{ textAlign: "center" }}>Ref No</th>
                                                                                                    <th style={{ textAlign: "center" }}>Üretilen No</th>
                                                                                                    <th style={{ textAlign: "center" }}>Uzunluk</th>
                                                                                                    <th style={{ textAlign: "center" }}>Box</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {
                                                                                                    itemKarekod.karekodUretilenList && itemKarekod.karekodUretilenList.length > 0 ?
                                                                                                        itemKarekod.karekodUretilenList.map((itemKarekodUretilen, indexKarekodUretilen) => {
                                                                                                            return (
                                                                                                                <tr key={"KarekodUretilen" + indexKarekodUretilen}>
                                                                                                                    <td align="center">{itemKarekodUretilen.karekodUretilen}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.urunOlcusu}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.sterilNo}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.expireDate}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.seriNo}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.lot}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.useBy}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.gtin}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.refNo}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.newNo}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.uzunluk}</td>
                                                                                                                    <td align="center">{itemKarekodUretilen.kutuNo}</td>
                                                                                                                </tr>
                                                                                                            )
                                                                                                        })
                                                                                                        :
                                                                                                        <tr>
                                                                                                            <td align="center" colSpan="12">
                                                                                                                Kayıt bulunamadı
                                                                                                            </td>
                                                                                                        </tr>
                                                                                                }
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        :
                                                                        ""
                                                                }
                                                            </React.Fragment>
                                                        )
                                                    })
                                                    :
                                                    <tr>
                                                        <td align="center" colSpan="5">
                                                            Kayıt bulunamadı
                                                        </td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row" style={{ placeItems: "center", padding: "8px" }}>
                                    <div className="col-md-4" style={{ display: "ruby" }}>
                                        <span className="badge bg-primary">{rowCount + " kayıt"}</span>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-center" }}>
                                        <div style={{ display: "flex", width: "224px" }}>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIlk()}><i className="bi bi-caret-left-fill"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavGeri()}><i className="bi bi-caret-left"></i></button>
                                            <div className="input-group">
                                                <input type="text" className="form-control form-control-xsm text-center" value={pageNo} onChange={(e) => handlePageNo(e.target.value)}></input>
                                                <div className="form-control form-control-xsm text-center" style={{ borderLeft: "none" }}>{" / " + lastPage}</div>
                                            </div>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavIleri()}><i className="bi bi-caret-right"></i></button>
                                            <button className="btn btn-sm btn-icon text-info" onClick={async () => NavSon()}><i className="bi bi-caret-right-fill"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-md-4" style={{ textAlign: "-webkit-right" }}>
                                        <select className="form-select form-select-xsm" style={{ width: "128px" }} value={pageSize} onChange={async (e) => handlePageSize(e.target.value)}>
                                            <option value="5">5 kayıt göster</option>
                                            <option value="10">10 kayıt göster</option>
                                            <option value="25">25 kayıt göster</option>
                                            <option value="50">50 kayıt göster</option>
                                            <option value="100">100 kayıt göster</option>
                                            <option value="250">250 kayıt göster</option>
                                            <option value="500">500 kayıt göster</option>
                                            <option value="1000">1000 kayıt göster</option>
                                            <option value="5000">5000 kayıt göster</option>
                                            <option value="10000">10000 kayıt göster</option>
                                        </select>
                                    </div>
                                </div>
                            </React.Fragment>
                            :
                            ""
            }

            <Modal show={showBulk} onHide={handleCloseBulk} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Karekod Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <div className="form-group">
                                <label htmlFor='tbMiktarData'>Miktar giriniz:</label>
                                <input id="tbMiktarData" type='number' className="form-control form-control-sm" value={miktarData} onChange={(e) => setMiktarData(e.target.value)} 
                                    placeholder='Miktar giriniz'></input>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className="form-group">
                                <label htmlFor='tbVeriData'>Veri Bölümü:</label>
                                <textarea id="tbVeriData" rows="10" className="form-control form-control-sm" value={veriData} onChange={(e) => setVeriData(e.target.value)} 
                                    placeholder='Excelde karekodlardan veya karekod ve steril numaralarından oluşan veri bölümünü buraya yapıştırınız'></textarea>
                            </div>
                        </div>
                    </div>     
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={() => KaydetBulk()}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleCloseBulk}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>

            <Modal show={showTek} onHide={handleCloseTek} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Karekod Kaydı</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-md-12 mb-3'>
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblKarekod" style={{ width: "120px" }}>Karekod<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                <input aria-describedby="lblKarekod" className="form-control form-control-sm" value={karekodData} onChange={(e) => setKarekodData(e.target.value)}></input>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className="input-group input-group-sm">
                                <label className="input-group-text" id="lblSterilNo" style={{ width: "120px" }}>Steril No<span style={{ color: "red", paddingLeft: "4px" }}>*</span></label>
                                <input aria-describedby="lblSterilNo" className="form-control form-control-sm" value={sterilNoData} onChange={(e) => setSterilNoData(e.target.value)}></input>
                            </div>
                        </div>
                    </div>     
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={() => KaydetTek()}><i className="bi bi-check-lg mr-2"></i> Kaydet</button>
                    <button className="btn btn-secondary" onClick={handleCloseTek}><i className="bi bi-x"></i> Vazgeç</button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default GridKarekod;